import React from "react";
import "../styles/PrivacyPolicyPage.css";

// 개인정보 처리방침.
//
// 본문은 PDF(LAWFORM 으로 작성한 이미지 문서)라 코드에서 고칠 수 없다.
// 광고·분석 도구를 붙이면서 생긴 행태정보 수집과 국외 이전 고지는 법령상
// 공개가 필요한데 PDF 를 손댈 수 없어, 이 화면에 따로 적는다.
//
// 본문 PDF 를 새로 만들 때 아래 내용을 조문으로 넣고 이 블록을 지우면 된다.

const EFFECTIVE_DATE = "2026년 10월 14일";

const PrivacyPolicy = () => {
    return (
        <div className="sch-privacy">
            <div className="sch-wrap sch-privacy__inner">
                <h1 className="sc-h2">개인정보 처리방침</h1>

                {/* ── 추가 고지 ───────────────────────────────── */}
                <section className="sch-privacy__notice">
                    <h2 className="sc-h3">온라인 맞춤형 광고 및 개인정보 국외 이전에 관한 안내</h2>
                    <p className="sch-privacy__eff">시행일 {EFFECTIVE_DATE}</p>
                    <p>
                        회사는 아래 내용을 개인정보 처리방침의 일부로 공개합니다.
                        본문은 이어지는 「개인정보 처리방침」 문서를 함께 확인해 주세요.
                    </p>

                    <h3 className="sc-h4">1. 행태정보의 수집·이용</h3>
                    <p>
                        회사는 이용자에게 맞는 광고를 제공하고 광고 성과를 측정하기 위하여
                        아래와 같이 행태정보를 수집·이용합니다.
                    </p>
                    <div className="sc-tablewrap">
                        <table className="sc-table">
                            <tbody>
                            <tr>
                                <th>수집하는 항목</th>
                                <td>
                                    웹사이트 방문 이력, 조회한 페이지, 클릭 등 이용자의 활동 정보,
                                    광고 식별자, 쿠키, 브라우저·기기 정보, 접속 IP 주소
                                </td>
                            </tr>
                            <tr>
                                <th>수집 방법</th>
                                <td>
                                    이용자가 웹사이트를 이용할 때 광고·분석 도구(Meta 픽셀,
                                    Google&nbsp;Analytics, 네이버 애널리틱스)가 자동으로 수집
                                </td>
                            </tr>
                            <tr>
                                <th>이용 목적</th>
                                <td>
                                    이용자의 관심에 기반한 맞춤형 광고 제공, 광고 성과 측정,
                                    웹사이트 이용 분석 및 서비스 개선
                                </td>
                            </tr>
                            <tr>
                                <th>보유·이용 기간</th>
                                <td>
                                    수집일로부터 최대 2년. 다만 이용자가 수집을 거부하거나
                                    쿠키를 삭제한 경우 그 시점부터 수집하지 않습니다.
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <p className="sch-privacy__note">
                        회사는 이용자의 사상·신념, 정치적 견해, 건강, 성생활 등 사생활을 뚜렷하게
                        침해할 우려가 있는 민감한 행태정보를 수집하지 않습니다.
                        또한 만 14세 미만임을 알고 있는 아동을 대상으로 맞춤형 광고를 제공하지 않습니다.
                    </p>

                    <h3 className="sc-h4">2. 개인정보의 국외 이전</h3>
                    <p>
                        위 도구를 이용하는 과정에서 아래와 같이 정보가 국외로 이전됩니다.
                    </p>
                    <div className="sc-tablewrap">
                        <table className="sc-table">
                            <thead>
                            <tr>
                                <th>이전받는 자</th>
                                <th>이전 국가</th>
                                <th>이전 항목</th>
                                <th>이전 목적 · 보유 기간</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Meta Platforms, Inc.</td>
                                <td>미국</td>
                                <td>쿠키, 광고 식별자, 방문·클릭 등 활동 정보, 브라우저·기기 정보, IP 주소</td>
                                <td>맞춤형 광고 제공 및 광고 성과 측정 / 이전받는 자의 정책에 따른 보유 기간</td>
                            </tr>
                            <tr>
                                <td>Google LLC</td>
                                <td>미국</td>
                                <td>쿠키, 방문·클릭 등 활동 정보, 브라우저·기기 정보, IP 주소</td>
                                <td>웹사이트 이용 분석 / 이전받는 자의 정책에 따른 보유 기간</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <p className="sch-privacy__note">
                        이전 일시 및 방법: 이용자가 웹사이트를 이용하는 시점에 정보통신망을 통하여 전송됩니다.
                    </p>

                    <h3 className="sc-h4">3. 이용자의 거부 방법</h3>
                    <p>
                        이용자는 아래 방법으로 행태정보 수집과 맞춤형 광고를 거부할 수 있습니다.
                        거부하더라도 회사 서비스 이용에는 제한이 없습니다.
                    </p>
                    <ul className="sch-privacy__list">
                        <li>
                            <b>브라우저에서 쿠키 차단</b> — 브라우저 설정에서 쿠키를 차단하거나
                            삭제하면 행태정보가 수집되지 않습니다. 네이버 애널리틱스는 별도
                            차단 도구를 제공하지 않아 이 방법으로 거부합니다. 설정 방법은{" "}
                            <a href="/cookie-policy">쿠키 정책</a>에 안내되어 있습니다.
                        </li>
                        <li>
                            <b>Meta(페이스북·인스타그램) 광고 설정</b> — 계정 설정의 「광고 기본 설정」에서
                            광고 주제와 광고주 데이터 사용을 조정할 수 있습니다.
                        </li>
                        <li>
                            <b>Google Analytics 수집 거부</b> —{" "}
                            <a href="https://tools.google.com/dlpage/gaoptout"
                               target="_blank" rel="noopener noreferrer">
                                구글 애널리틱스 차단 브라우저 부가기능 ↗
                            </a>
                            을 설치하면 수집되지 않습니다.
                        </li>
                    </ul>

                    <h3 className="sc-h4">4. 문의처</h3>
                    <p>
                        행태정보와 관련한 문의·거부·피해 구제는 아래로 연락해 주세요.
                    </p>
                    <ul className="sch-privacy__list">
                        <li>개인정보 보호 책임자: 박찬엽 (대표)</li>
                        <li>
                            전화: <a href="tel:01044147579">010-4414-7579</a> ·
                            이메일: <a href="mailto:oracle7579@gmail.com">oracle7579@gmail.com</a>
                        </li>
                    </ul>
                </section>

                {/* ── 본문 ────────────────────────────────────── */}
                <h2 className="sc-h3 sch-privacy__docTitle">개인정보 처리방침 (본문)</h2>
                <p className="sch-privacy__note">
                    아래 문서가 보이지 않으면{" "}
                    <a href="/raw/소프트캣_개인정보처리방침.pdf" target="_blank" rel="noopener noreferrer">
                        PDF로 바로 열기 ↗
                    </a>
                </p>
                <iframe
                    className="sch-privacy__pdf"
                    src="/raw/소프트캣_개인정보처리방침.pdf"
                    title="소프트캣 개인정보 처리방침"
                />
            </div>
        </div>
    );
};

export default PrivacyPolicy;
